import { createApi } from "../axiosInstance";
import { createActivitiesApi } from "../shared/activitiesApiFactory";

// Legal/Annual/Capacity Building/Business Plan/AGM & Board are owned by the central fpo
// service, same as MyBusiness/complianceApi.js's statutory domains -- call fpo directly
// instead of proxying through mybusiness's own port.
const api = createApi("myFPO");

export const {
  registerLegalCompliance,
  getLegalCompliance,
  getLegalComplianceByTenant,
  updateLegalComplianceStatus,
  registerAnnualCompliance,
  getAnnualCompliance,
  getAnnualComplianceByTenant,
  updateAnnualComplianceStatus,
  registerCapacityBuilding,
  getCapacityBuilding,
  getCapacityBuildingByTenant,
  updateCapacityBuildingStatus,
  registerBusiness,
  getBusiness,
  getBusinessByTenant,
  updateBusinessStatus,
  addAGMBoards,
  getAGMBoards,
  getAgmDocuments,
  getMyAgmOrganisations,
  uploadAgmDocuments,
  updateAgmDocument,
  getMembershipDashboard,
  getShareCapitalDashboard,
  getTurnoverDashboard,
} = createActivitiesApi(api, "MY_BUSINESS");

// These two are genuinely mybusiness-native endpoints (mybusiness/.../DashboardController.java,
// port 8007) -- unlike everything above, which is owned by fpo. Must use a separate myBusiness
// api instance, not the file-level `api` (myFPO) -- confirmed live this was a real bug: using
// `api` sent these requests to port 8006 where /company/{id}/dashboard/... 404s.
const businessApi = createApi("myBusiness");

export const getBusinessTurnoverDashboard = (companyId, params) =>
  businessApi.get(`/company/${companyId}/dashboard/turnover`, { params });
export const getBusinessShareCapitalDashboard = (companyId, params) =>
  businessApi.get(`/company/${companyId}/dashboard/share-capital`, { params });
